// modules
import { handleActions } from 'redux-actions'

// actions
import {
  removeMinimizedModal,
  setActionCounter,
  setActivityClinicalEventsModalOpen,
  setActivityClinicalEventsModalPatient,
  setActivityModalInitialValues,
  setActivityModalIsSuccessed,
  setActivityModalOpen,
  setActivityTimerExtra,
  setActivityTimerModalInitialValues,
  setActivityTimerModalIsSuccessed,
  setActivityTimerModalOpen,
  setActivityTimerRecording,
  setCareTeams,
  setCommonAgencyCaseManagers,
  setHeaderAddActivityBillingCodeList,
  setMedicalDeviceTypes,
  setMinimizedModals,
  setPatientAddActivityBillingCodeList,
  setPatientCaseManagers,
  setTelemedicineOutcomeModalInitialValue,
  setTimerAddActivityBillingCodeList,
  setTranscriptionModalInitialValue,
  setTranscriptionModalSaved,
  setTranscriptionModalVisible,
  setUrgentCareCallUuid,
  setUrgentCareOutcomeModalInitialValue,
  setUrgentCareOutcomeModalSaved,
  setUrgentCareOutcomeModalVisible,
  toggleReferenceTableShowInactive
} from 'src/store/modules/common'

const initialState = {
  timerAddActivityBillingCodeList: [],
  headerAddActivityBillingCodeList: [],
  patientAddActivityBillingCodeList: [],
  minimizedModals: [],
  agencyCaseManagementList: [],
  medicalDeviceTypes: [],
  urgentCareOutcomeModalVisible: false,
  urgentCareCallUuid: null,
  urgentCareOutcomeModalInitialValue: {},
  urgentCareOutcomeModalSaved: false,
  transcriptionModalVisible: false,
  transcriptionModalInitialValue: {},
  transcriptionModalSaved: false,
  telemedicineOutcomeModalInitialValue: {},
  careTeams: [],
  activityModalOpen: false,
  activityClinicalEventsModalOpen: false,
  setActivityClinicalEventsModalPatient: '',
  activityModalInitialValues: null,
  activityModalIsSuccessed: false,
  activityTimerModalOpen: false,
  activityTimerModalInitialValues: {},
  activityTimerModalIsSuccessed: false,
  activityTimerRecording: false,
  patientCaseManagers: [],
  referenceTableDisplayInactive: false,
  actionCounter: [],
  timerExtra: {}
}

export default handleActions(
  {
    [setTimerAddActivityBillingCodeList](
      state,
      { payload: timerAddActivityBillingCodeList }
    ) {
      return {
        ...state,
        timerAddActivityBillingCodeList
      }
    },

    [setHeaderAddActivityBillingCodeList](
      state,
      { payload: headerAddActivityBillingCodeList }
    ) {
      return {
        ...state,
        headerAddActivityBillingCodeList
      }
    },

    [setPatientAddActivityBillingCodeList](
      state,
      { payload: patientAddActivityBillingCodeList }
    ) {
      return {
        ...state,
        patientAddActivityBillingCodeList
      }
    },

    [setMinimizedModals](state, { payload: minimizedModals }) {
      return {
        ...state,
        minimizedModals
      }
    },

    [removeMinimizedModal](state, { payload: id }) {
      return {
        ...state,
        minimizedModals: state.minimizedModals
          .filter(({ id: itemId }) => itemId !== id)
          .map((item, key) => ({ ...item, key: ++key }))
      }
    },

    [setCommonAgencyCaseManagers](
      state,
      { payload: agencyCaseManagementList }
    ) {
      return {
        ...state,
        agencyCaseManagementList
      }
    },

    [setMedicalDeviceTypes](state, { payload: medicalDeviceTypes }) {
      return {
        ...state,
        medicalDeviceTypes
      }
    },

    [setUrgentCareOutcomeModalVisible](
      state,
      { payload: urgentCareOutcomeModalVisible }
    ) {
      return {
        ...state,
        urgentCareOutcomeModalVisible
      }
    },

    [setUrgentCareOutcomeModalInitialValue](
      state,
      { payload: urgentCareOutcomeModalInitialValue }
    ) {
      return {
        ...state,
        urgentCareOutcomeModalInitialValue
      }
    },

    [setUrgentCareOutcomeModalSaved](
      state,
      { payload: urgentCareOutcomeModalSaved }
    ) {
      return {
        ...state,
        urgentCareOutcomeModalSaved
      }
    },

    [setUrgentCareCallUuid](state, { payload: urgentCareCallUuid }) {
      return {
        ...state,
        urgentCareCallUuid
      }
    },

    [setTranscriptionModalVisible](
      state,
      { payload: transcriptionModalVisible }
    ) {
      return {
        ...state,
        transcriptionModalVisible
      }
    },

    [setTranscriptionModalInitialValue](
      state,
      { payload: transcriptionModalInitialValue }
    ) {
      return {
        ...state,
        transcriptionModalInitialValue
      }
    },

    [setTranscriptionModalSaved](state, { payload: transcriptionModalSaved }) {
      return {
        ...state,
        transcriptionModalSaved
      }
    },

    [setTelemedicineOutcomeModalInitialValue](
      state,
      { payload: telemedicineOutcomeModalInitialValue }
    ) {
      return {
        ...state,
        telemedicineOutcomeModalInitialValue
      }
    },

    [setCareTeams](state, { payload: careTeams }) {
      return {
        ...state,
        careTeams
      }
    },

    [setActivityModalOpen](state, { payload: activityModalOpen }) {
      return {
        ...state,
        activityModalOpen
      }
    },

    [setActivityClinicalEventsModalOpen](
      state,
      { payload: activityClinicalEventsModalOpen }
    ) {
      return {
        ...state,
        activityClinicalEventsModalOpen
      }
    },

    [setActivityClinicalEventsModalPatient](
      state,
      { payload: activityClinicalEventsModalPatient }
    ) {
      return {
        ...state,
        activityClinicalEventsModalPatient
      }
    },

    [setActivityModalInitialValues](
      state,
      { payload: activityModalInitialValues }
    ) {
      return {
        ...state,
        activityModalInitialValues
      }
    },

    [setActivityModalIsSuccessed](
      state,
      { payload: activityModalIsSuccessed }
    ) {
      return {
        ...state,
        activityModalIsSuccessed
      }
    },

    [setActivityTimerModalOpen](state, { payload: activityTimerModalOpen }) {
      return {
        ...state,
        activityTimerModalOpen
      }
    },

    [setActivityTimerModalInitialValues](
      state,
      { payload: activityTimerModalInitialValues }
    ) {
      return {
        ...state,
        activityTimerModalInitialValues:
          state.activityTimerModalInitialValues.startTime &&
          activityTimerModalInitialValues.startTime
            ? {
                ...activityTimerModalInitialValues,
                startTime: state.activityTimerModalInitialValues.startTime
              }
            : activityTimerModalInitialValues,
        timerExtra:
          !state.activityTimerModalInitialValues?.patient?.uuid ||
          state.activityTimerModalInitialValues?.patient?.uuid ===
            activityTimerModalInitialValues?.patient?.uuid
            ? state.timerExtra
            : {}
      }
    },

    [setActivityTimerModalIsSuccessed](
      state,
      { payload: activityTimerModalIsSuccessed }
    ) {
      return {
        ...state,
        activityTimerModalIsSuccessed
      }
    },

    [setActivityTimerRecording](state, { payload: activityTimerRecording }) {
      return {
        ...state,
        activityTimerRecording
      }
    },

    [setActivityTimerExtra](state, { payload: timerExtra }) {
      return {
        ...state,
        timerExtra
      }
    },

    [setPatientCaseManagers](state, { payload: patientCaseManagers }) {
      return {
        ...state,
        patientCaseManagers
      }
    },

    [setActionCounter](state, { payload: actionCounter }) {
      return {
        ...state,
        actionCounter
      }
    },
    [toggleReferenceTableShowInactive](state, { payload }) {
      return {
        ...state,
        referenceTableShowInactive: !state.referenceTableShowInactive
      }
    }
  },
  initialState
)
